import { mapErrors } from "@insightfulscience/shared-utils/fn";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import * as Customer from "../services/customer";
import getOperationError from "../apollo/operation-errors";
import routes, { gotoPath } from "../routes";
import { withLoading } from "../nprogress";

const forgotPassword = form =>
	Customer.getCustomerForgotPasswordLink(form)
		.then(gotoPath(routes.forgotPasswordSuccess))
		.catch(mapErrors(getOperationError));

export default pipe(forgotPassword, withLoading("forgot-password"));
